import { EMPTY_STRING, LAST_ELEMENT, ZERO, STEP, SCATTER_CHART_LABEL_MAX_LENGHT } from '@constants';
import { DefaultLabelFormatterCallbackParams } from 'echarts';

import { truncateString } from './truncateString';

export const chartStringFormatter =
  (template: string) =>
  (parameters: unknown): string => {
    const params = parameters as DefaultLabelFormatterCallbackParams;
    if (!params.data || typeof params.data !== 'object') {
      return EMPTY_STRING;
    }

    const { value, align } = params.data as { value?: (number | string)[]; align?: string };

    return template.replace(/{(\w+)(?:_(\d+))?}/g, (_, key: string) => {
      if (!Number.isNaN(Number(key.at(LAST_ELEMENT))) && Array.isArray(value)) {
        const idx = Number(key.at(LAST_ELEMENT));

        return idx >= ZERO && idx < value.length ? String((value[idx] as number).toFixed(STEP)) : EMPTY_STRING;
      }

      if (key === 'marker') return params.marker as string;

      const label = params.data![key as keyof typeof params.data];
      const truncatedLabel = truncateString(String(label), SCATTER_CHART_LABEL_MAX_LENGHT);
      const richLabel = `{${align ?? EMPTY_STRING}|${String(truncatedLabel)}}`;
      const finalLabel = align ? richLabel : String(label);

      return label !== undefined ? finalLabel : EMPTY_STRING;
    });
  };
